import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Train = ({ size, color = tailwindConfig.theme.colors.gray[600] }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.3999 27.2L11.1999 23.968"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5998 27.2L20.7998 23.968"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0162 4.80005H8.04824C7.16459 4.80005 6.44824 5.51639 6.44824 6.40005V22.368C6.44824 23.2517 7.16459 23.968 8.04824 23.968H24.0162C24.8999 23.968 25.6162 23.2517 25.6162 22.368V6.40005C25.6162 5.51639 24.8999 4.80005 24.0162 4.80005Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M25.5682 11.1841H6.36816V16.0001H25.5682V11.1841Z" fill={color} />
      <path
        d="M18.8001 7.96802H13.1681C12.9472 7.96802 12.7681 8.1471 12.7681 8.36802V9.16802C12.7681 9.38893 12.9472 9.56802 13.1681 9.56802H18.8001C19.021 9.56802 19.2001 9.38893 19.2001 9.16802V8.36802C19.2001 8.1471 19.021 7.96802 18.8001 7.96802Z"
        fill={color}
        stroke={color}
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        d="M20.8002 20.7681C21.6839 20.7681 22.4002 20.0518 22.4002 19.1681C22.4002 18.2845 21.6839 17.5681 20.8002 17.5681C19.9165 17.5681 19.2002 18.2845 19.2002 19.1681C19.2002 20.0518 19.9165 20.7681 20.8002 20.7681Z"
        fill={color}
      />
      <path
        d="M11.2001 20.7681C12.0838 20.7681 12.8001 20.0518 12.8001 19.1681C12.8001 18.2845 12.0838 17.5681 11.2001 17.5681C10.3164 17.5681 9.6001 18.2845 9.6001 19.1681C9.6001 20.0518 10.3164 20.7681 11.2001 20.7681Z"
        fill={color}
      />
    </svg>
  );
};

export default Train;
